var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Head',{attrs:{"title":"Businesses"}}),_vm._v(" "),_c('h1',{staticClass:"mb-8 text-3xl font-bold"},[_vm._v("Business")]),_vm._v(" "),_c('div',{staticClass:"bg-white rounded-md shadow overflow-x-auto"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }